import React, { ComponentProps, ReactNode } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { CheckBoxParam, Form, Row, SonForm, SubmitButton, Switch, useForm } from '../../../_lib/Form2';
import { translatePartOfStringWithLink } from '../../../lib/StringUtils/StringHTMLUtils';
import { Namespace } from '../../../translation/namespace';
import { useNavigate } from 'react-router';
import { useDelayed } from '../../../hooks/useDelayed';

type PageLayoutFormProps = {
  reloadUrl: string;
  form: SonForm<CheckBoxParam<'fullWidthLayout'>>;
};
function PageLayoutDefault({ reloadUrl, form }: PageLayoutFormProps) {
  const { t } = useSonTranslation('PageLayout');
  const navigate = useNavigate();
  const delayedPageReload = useDelayed(() => {
    navigate(0);
  });

  const { formProps, params, hasChanges, fetchState } = useForm({
    form,
    onSuccess: delayedPageReload,
  });

  const fullWidthLayoutParam = params.getByName('fullWidthLayout');

  const getReloadMessage = (): ReactNode => {
    return translatePartOfStringWithLink(`${Namespace.PageLayout}:successReloadMessage`, reloadUrl, false);
  };

  return (
    <Form id="page-layout-form" {...formProps}>
      <Row>
        <Switch modifierLabel="position-inherit" label={t('switchLabel')} param={fullWidthLayoutParam} />
      </Row>
      <SubmitButton
        buttonLabel={t('phrases:saveChanges')}
        messageSuccess={getReloadMessage()}
        messageSending={t('phrases:processIsCurrentlyRunningWithDots')}
        messageFail={t('phrases:changesCouldNotBeSaved')}
        fetchState={fetchState}
        // for now, until all accordion items with form2 written
        active={hasChanges}
      />
    </Form>
  );
}
export const PageLayoutDefaultView = asView(PageLayoutDefault);
export type PageLayoutDefaultView = ComponentProps<typeof PageLayoutDefaultView>;
